import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-careers-create",
  templateUrl: "./careers-create.component.html",
  styleUrls: ["./careers-create.component.scss"],
})
export class CareersCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  public course = [];

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      // console.log(`${id}`);
      this.http
        .get<any>(this.api_endpoint + "/careersbyid/" + `${id}`)
        .subscribe(
          (data) => {
            // console.log(data.data);
            if (data.data != null) {
              this.action = "Update";
              this.Form.patchValue({
                _id: data.data._id,
                college: data.data.college,
                openings: data.data.openings,
                position: data.data.position,
                details: data.data.details,
                seohidden: data.data.seohidden
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    this.Form = this.formBuilder.group({
      college: ["", Validators.required],
      openings: ["", Validators.required],
      position: ["", Validators.required],
      details: ["", Validators.required],
      seohidden: [''],
      _id: [""],
    });
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      var data = {
        college: this.Form.value.college,
        openings: this.Form.value.openings,
        position: this.Form.value.position,
        details: this.Form.value.details,
        admin: sessionStorage.getItem("adminName"),
        seohidden: this.Form.value.seohidden
      };
      // console.log(data);
      this.http.post<any>(this.api_endpoint + "/careers", data).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/careers/list-page");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured." + err);
          }
        }
      );
    } else {
      var data1 = {
        college: this.Form.value.college,
        openings: this.Form.value.openings,
        position: this.Form.value.position,
        details: this.Form.value.details,
        admin: sessionStorage.getItem("adminName"),
        _id: this.Form.value._id,
        seohidden: this.Form.value.seohidden,
        
      };
      // console.log(data1);
      this.http.put<any>(this.api_endpoint + "/careers/", data1).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/careers/list-page");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    }
  }
}
